import { Flex } from '@/ui/Flex/Flex';
import { T } from '@/ui/Text/Text';
import { memo } from 'react';
import { useIntl } from 'react-intl';
import SensorHandle from '../SensorHandle';
import { SensorBuzzerNodeType } from '../types';
import BaseNode from '../BaseNode';

export const SensorBuzzerNode = memo(
  ({
    data,
    selected,
    disabled,
  }: {
    data: SensorBuzzerNodeType['data'];
    selected?: boolean;
    disabled?: boolean;
  }) => {
    const intl = useIntl();
    const { buzzers, language } = data.options;
    return (
      <BaseNode
        selected={selected ?? false}
        type="sensor"
        isValid={data.isValid}
        disabled={disabled ?? false}
      >
        <Flex direction="column">
          <T h4>
            {intl.formatMessage({
              defaultMessage: 'Buzzer',
              id: '8oBAWC',
            })}
          </T>
          <T body2>
            {buzzers && buzzers.length > 0
              ? `${buzzers.length === 1 ? buzzers[0].name : 'Buzzers'} | ${language ?? intl.formatMessage({ defaultMessage: 'Any', id: 'ToO3/h' })}`
              : 'Name'}
          </T>
        </Flex>
        <SensorHandle id="active" disabled={disabled} />
      </BaseNode>
    );
  },
);
